import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { log } from 'console';

@Component({
  selector: 'app-claro-tooltip-icon',
  templateUrl: './claro-tooltip-icon.component.html',
  styleUrl: './claro-tooltip-icon.component.scss',
})
export class ClaroTooltipIconComponent extends BaseComponent {
  @Input() iconName = 'question_mark';
  @Input() translatedTooltipText = '';
  isTooltipVisible = false;
  // tooltipPosition = { left: '', top: '' };
  tooltipPosition = { transform: 'none' };
  isTouchDevice = false; // for easy mobile in desktop view testing
  @ViewChild('tooltipContent') tooltipElementRef: ElementRef;

  constructor(private elementRef: ElementRef) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isTouchDevice =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent): void {
    if (this.isHandHeldDevice || this.isTouchDevice) return;
    this.showTooltip(event);
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (!this.isHandHeldDevice) {
      // console.log('onMouseLeave');
      this.isTooltipVisible = false;
    }
  }

  @HostListener('click', ['$event'])
  onTooltipIconClick(event: MouseEvent): void {
    event?.stopPropagation();
    if (!event || this.isTooltipVisible) return;
    this.showTooltip(event);
    setTimeout(() => {
      this.isTooltipVisible = false;
    }, 4000);
  }

  private showTooltip(event: MouseEvent | Touch): void {
    this.isTooltipVisible = true;
    this.setTooltipPosition(event);
  }

  private setTooltipPosition(event: MouseEvent | Touch): void {
    const iconElement = event.target as HTMLElement;
    const iconRect = iconElement.getBoundingClientRect();

    if (this.tooltipElementRef) {
      const tooltipRect =
        this.tooltipElementRef.nativeElement.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // left positive is moving right, negative is moving left
      let left = iconRect.left - 70;
      // top positive is moving down, negative is moving up
      let top = iconRect.bottom + 2;
      // transform first argument is for horizontal, second is for vertical
      // for first arg minus is for moving left, plus is for moving right
      // for second arg minus is for moving up, plus is for moving down
      let transform;
      if (this.isHandHeldDevice) {
        transform = 'translate(-10%, 65%)';
      } else {
        transform = 'translate(0%, 63%)';
      }

      // Check if the tooltip exceeds the right edge of the window
      if (left > windowWidth - 150) {
        // console.log('exceeds right edge ');
        // left = iconRect.left - 200;
        if (this.isHandHeldDevice) {
          transform = 'translate(-45%, 53%)';
        } else {
          transform = 'translate(-40%, 60%)';
        }
      }

      // Check if the tooltip exceeds the left edge of the window
      if (left < 40) {
        // console.log('exceeds left edge');
        // left = tooltipRect.width / 2 + 20;
        if (this.isHandHeldDevice) {
          transform = 'translate(38%, 60%)';
        } else {
          transform = 'translate(38%, 60%)';
        }
      }

      // Check if the tooltip exceeds the bottom edge of the window
      if (top > windowHeight - 150) {
        if (this.isHandHeldDevice) {
          // console.log('exceeds bottom edge in mobile');
          top = iconRect.bottom - 100;
          transform = 'translate(-40%, -60%)';
        }else{
          // console.log('exceeds bottom edge');
          top = iconRect.top - tooltipRect.height - 20;
          transform = 'translate(5%, -70%)';
        }
      }

      this.tooltipPosition = {
        // left: `${left}px`,
        // top: `${top}px`,
        transform: transform,
      };
    }
  }
}
